module.exports = __webpack_public_path__ + "img/clue3.495c197b.jpg";